import React from "react";
import PageHeader from "@/components/PageHeader";
import VisaServices from "@/components/VisaServices";
import CtaBanner from "@/components/CtaBanner";
import { useLayout } from "@/components/Layout";
import { motion } from "framer-motion";
import { FileCheck2, CalendarClock, ShieldCheck, Headphones } from "lucide-react";

const STEPS = [
  { icon: FileCheck2, title: "Document review", text: "We audit your paperwork against the embassy's latest checklist — before submission." },
  { icon: CalendarClock, title: "Appointment booking", text: "Priority appointment slots and biometric scheduling handled by our team." },
  { icon: ShieldCheck, title: "Interview prep", text: "One-on-one coaching for visa interviews — question banks, mock sessions, tips." },
  { icon: Headphones, title: "24×7 assistance", text: "A dedicated visa officer follows your case from start to stamp." },
];

export default function VisaPage() {
  const { openPlan } = useLayout();
  return (
    <div data-testid="visa-page">
      <PageHeader
        overline="Visa Services"
        title={"500+ visas approved.\nZero paperwork stress."}
        subtitle="From document checklists to interview prep and biometric appointments — our visa specialists handle the entire journey. You only show up for the holiday."
        image="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?q=80&w=2000&auto=format&fit=crop"
      />

      {/* How it works */}
      <section className="py-24 md:py-32 px-6 lg:px-10 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-10 h-px bg-[#C9A227]" />
            <span className="overline">How it works</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-[#0A2342] max-w-2xl leading-[1.05]">
            A concierge-grade visa experience.
          </h2>

          <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="lux-card p-7"
              >
                <div className="w-12 h-12 rounded-2xl bg-[#F8F9FB] flex items-center justify-center mb-5">
                  <s.icon className="w-5 h-5 text-[#C9A227]" />
                </div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#C9A227] mb-1">Step {i + 1}</div>
                <h3 className="font-display text-xl text-[#0A2342]">{s.title}</h3>
                <p className="mt-2 text-sm text-[#6B7280] leading-relaxed">{s.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <VisaServices onApply={(name) => openPlan({ destination: `${name} Visa` })} />
      <CtaBanner onPlanTrip={() => openPlan()} />
    </div>
  );
}
